import _pt from "prop-types";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cx from 'classnames';
export default function Circle(_ref) {
  var className = _ref.className,
      innerRef = _ref.innerRef,
      restProps = _objectWithoutPropertiesLoose(_ref, ["className", "innerRef"]);

  return /*#__PURE__*/React.createElement("circle", _extends({
    ref: innerRef,
    className: cx('vx-circle', className)
  }, restProps));
}
Circle.propTypes = {
  className: _pt.string,
  innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/shape/esm/shapes/Circle.js
// module id = 771
// module chunks = 0